export default "__VITE_ASSET__BJkwn6BI__"